import { gql } from '@/store/helpers/axios.js'

export default {
  async UPLOAD_FILE_TO_CLOUDINARY ({ state, commit }, formData) {
    const {
      gesuchId,
      gesuchKey,
      fileName,
      fileContentBase64
    } = formData

    const query = `mutation fileUploadCloudinary($input: FileUploadCloudinaryInput!) {
        fileUploadCloudinary (input: $input) {
          erstelltAm
          erstelltVon
          fileName
          filePositionId
          gesuchId
          cloudinaryResponseType
      }
    }`

  const variables = {
    input: {
      gesuchId,
      gesuchKey,
      fileName,
      fileContentBase64
    }
  }

  const { data } = await gql({ query, variables })

  return data
},

async DELETE_FILE_IN_CLOUDINARY ({ state, commit }, formData) {
  const {
    gesuchId,
    gesuchKey,
    fileName
  } = formData

  const query = `mutation fileDeleteInCloudinary($input: FileDeleteInCloudinaryInput!) {
      fileDeleteInCloudinary (input: $input) {
        deletedAm
        cloudinaryResponseType
      }
  }`

const variables = {
  input: {
    gesuchId,
    gesuchKey,
    fileName
  }
}

const { data } = await gql({ query, variables })

return data
},

async GET_FILES_HISTORY ({ commit }, gesuchId) {
  const query = `query cloudinaryFileHistory ($gesuchId: Int!
    $order_by: FileListDtoSort
    $where: FileListDtoFilter) {
      cloudinaryFileHistory (gesuchId: $gesuchId order_by: $order_by where: $where) {
      fileId
      deleteAllowed
      clientDownloadAllowed
      fileName
      erstelltAm
    }
  }`

  const variables = {
    gesuchId: Number(gesuchId),
    order_by: {
      erstelltAm: 'ASC'
    }
  }

  const { data } = await gql({ query, variables })

  if (!data.errors) {
    commit('SET_UPLOADED_FILES', data.data.cloudinaryFileHistory)
  }

  return data
},

async SIGN_AND_SEND ({ state, commit }, gesuchKey) {
  const query = `mutation handInAdditionalFiles($gesuchKey: String) {
      handInAdditionalFiles (gesuchKey: $gesuchKey) {
        ok
    }
  }`

const variables = {
  gesuchKey
}

const { data } = await gql({ query, variables })

return data
},

async GET_USER_FILES_TO_DOWNLOAD ({ commit }, gesuchId) {
  const query = `query userFilesForDownload ($gesuchId: Int!
    $order_by: FileDownloadDtoSort
    $where: FileDownloadDtoFilter) {
      userFilesForDownload (gesuchId: $gesuchId order_by: $order_by where: $where) {
      fileId
      fileName
      filePath
      erstelltAm
      deleteAllowed
      clientDownloadAllowed
      fileType
      fileContentBase64
    }
  }`

  const variables = {
    gesuchId: Number(gesuchId)
  }

  const { data } = await gql({ query, variables })

  if (!data.errors) {
    commit('SET_CLIENT_DOWNLOAD_FILES', data.data.userFilesForDownload)
  }

  return data
}
}
